module.exports = __webpack_public_path__ + "img/chevrons-up.a127f7fd.svg";